import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "label", "to", "className", "onClick", "aria-label", "ariaLabel"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { navigate, Link } from 'gatsby';
import _get from 'lodash/get';
import { arePathsEqual, getInternalLinkProps } from './InternalLink.utils';
import { withEvent } from '../../modules/analytics/components/Event';
import { isPageTransitionEnabled, PageTransitionController } from '../../modules/animations/components/PageTransition/PageTransition.utils';
import { ChildrenPropType } from '../../services/proptypes';
var defaultProps = {
  label: '',
  className: '',
  children: null,
  onClick: null,
  'aria-label': '',
  ariaLabel: ''
};
function InternalLink(_ref) {
  var children = _ref.children,
    label = _ref.label,
    to = _ref.to,
    className = _ref.className,
    onClickProp = _ref.onClick,
    ariaLabelDom = _ref['aria-label'],
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerProps = getInternalLinkProps(_objectSpread({
    to: to,
    className: className,
    label: label,
    ariaLabel: ariaLabelDom || ariaLabel
  }, rest));
  function onClick(_x, _x2) {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, target) {
      var currentPathname, controller;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            if (onClickProp) {
              onClickProp(event, target);
            }
            if (!to) {
              _context.next = 10;
              break;
            }
            currentPathname = _get(window, 'location.pathname', '');
            if (!(isPageTransitionEnabled() && !arePathsEqual(currentPathname, to))) {
              _context.next = 8;
              break;
            }
            controller = new PageTransitionController();
            _context.next = 8;
            return controller.pageOut();
          case 8:
            _context.next = 10;
            return navigate(to);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({}, containerProps, {
    onClick: onClick
  }), children || label);
}
InternalLink.defaultProps = defaultProps;
export default withEvent('click')(InternalLink);